import { userReducer } from './reducer';
import { storesReducer } from './storesReducer';
import { clientsReducer } from './clientsReducer';
import { uiReducer } from './uiReducer';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';

const storesPersistConfig = {
  key: 'stores',
  storage,
  whitelist: ['selectedStore'],
};

const clientsPersistConfig = {
  key: 'clients',
  storage,
  whitelist: ['selectedClient'],
};

const uiPersistConfig = {
  key: 'ui',
  storage: storageSession,
  whitelist: ['savvybotMessages', 'savvybotActiveSessionId'],
};

const rootReducer = combineReducers({
  user: userReducer,
  stores: persistReducer(storesPersistConfig, storesReducer),
  clients: persistReducer(clientsPersistConfig, clientsReducer),
  ui: persistReducer(uiPersistConfig, uiReducer),
});

export const setupStore = (preloadedState) => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      });

      return middleware;
    },
    preloadedState,
  });

  const persistor = persistStore(store);

  return { store, persistor };
};

export default setupStore;
